import React from 'react';
import {
  Input,
  DatePicker,
  Switch,
  InputNumber,
} from '@bedrock/components';
import { ProTable } from '@bedrock/eed-react';
import classNames from 'classnames';
import PureText from './PureText';
import './index.less';
import TextAreaPopover from '../SForm/SFormElement/TextAreaPropover';
import TextAreaWithUpload from '#components/SForm/SFormElement/TextAreaWithUpload';

function valueToArray(value: any) {
  if (Array.isArray(value)) return value;
  return [value];
}

const defaultProps = {
  className: 'mpc-quote-filed',
};

ProTable.addEditRender(
  'mpc-textArea',
  ({ props, setRow, toggleEditableRowKey, getRowKey }, editable) => ({
    component: editable
      ? TextAreaPopover
      : (props) => (
          <div
            onClick={() => {
              toggleEditableRowKey?.(
                getRowKey?.(props?.row) as string,
                editable
              );
            }}
          >
            <TextAreaPopover {...props} view="view"/>
          </div>
        ),
    props: {
      ...props,
      className: classNames(defaultProps.className, props.className),
    },
  })
);






ProTable.addEditRender(
  'switch-quote',
  ({ props, setRow, toggleEditableRowKey, getRowKey }, editable) => {
    return {
      component: editable
        ? Switch
        : (props) => (
            <div
              onClick={() => {
                toggleEditableRowKey?.(
                  getRowKey?.(props.row) as string,
                  editable
                );
              }}
            >
              <Switch {...props} disabled />
            </div>
          ),
      props: {
        ...props,
        onChange(e, row, column, rowIndex, ...args) {
          const changedRow = {
            ...row,
            [column.dataIndex as any]: e.target.value,
          };
          setRow(changedRow);
          props?.onChange?.(e, changedRow, column, rowIndex, ...args);
        },
      },
    };
  }
);


ProTable.addEditRender(
  'text_with_upload',
  ({ props, setRow, toggleEditableRowKey, getRowKey }, editable) => {
    return {
      component: TextAreaWithUpload,
      props: {
        ...props,
        onChange(e, row, column, rowIndex, ...args) {
          const changedRow = {
            ...row,
            [column.dataIndex as any]: e.target.value,
          };
          setRow(changedRow);
          props?.onChange?.(e, changedRow, column, rowIndex, ...args);
        },
      },
    };
  }
);

// @ts-ignore
ProTable?.addBatchEditRender?.('inputNumber', ({ props }) => ({
  component: InputNumber,
  props: {
    ...props,
    onChange(e, column, rowIndex, ...args) {
      props?.onChange?.(e, column, rowIndex, ...args);
    },
  },
}));

ProTable?.addBatchEditRender?.('dateRange', ({ props }) => ({
  component: DatePicker,
  props: {
    range: true,
    ...props,
    onChange(e, column, rowIndex, ...args) {
      props?.onChange?.(e, column, rowIndex, ...args);
    },
  },
}));

